/**
 * Flatten error response for details to object with { [key]: errorString format }
 * @param details
 * @returns {{}}
 */
import { convertTStoIsoString } from '@beef/shop-common';

import { FeedbackValidatedFields } from './constants';

export const mapErrorResponseDetails = (details) =>
  Object.keys(details).reduce((result, field) => {
    // ignore errors for non-existent fields
    if (FeedbackValidatedFields.indexOf(field) !== -1) {
      result[field] = details[field].ErrorMessage;
    }
    return result;
  }, {});

/**
 * Accepts newRatingString in following format:
 * 'likedId1,likedId2|dislikedId1,dislikedId2'
 * and turns it into object { liked: [likedId1, likedId2], disliked: [dislikedId1, dilikedId2] }
 */
export const unpackNewRating = (newRatingStr = '|') => {
  const [likedIds, dislikedIds] = newRatingStr.split('|');
  return {
    liked: likedIds
      .split(',')
      .filter((item) => !!item)
      .map((number) => parseInt(number, 10)),
    disliked: dislikedIds
      .split(',')
      .filter((item) => !!item)
      .map((number) => parseInt(number, 10)),
  };
};

/**
 * Reverse function for unpackNewRating, accepts object with rating and converts it back to string
 */
export const packNewRating = ({ liked, disliked }) => `${liked.join(',')}|${disliked.join(',')}`;

/**
 * Function for lowercase first letter, common use in mapping properties from model
 */
export const decapitalizeFirstLetter = (string) => string.charAt(0).toLowerCase() + string.slice(1);
/**
 * Function for transform input date in format : /Date(date time stamp)/ to string with timestamp
 * and then timestamp transforms to ISO format
 */
export const convertFeedbackModelDate = (date) => convertTStoIsoString(date.slice(6, -2));
/**
 * Function for mapping model legacy data with capitalised properties to actual decapitalised prop
 */
export const convertFeedbackPosts = (feedbacksData) => {
  return feedbacksData.FeedbacksList.map((feedback) => {
    const mappedFeedback = {};

    Object.keys(feedback).forEach((propertyOldName) => {
      /** OldName -> Name example Text -> text */
      const propertyName = decapitalizeFirstLetter(propertyOldName);
      /**
       * Where difference in name not just in capital letter,
       * we will check them one by one,
       */
      if (propertyName === 'feedbackId') {
        mappedFeedback.id = feedback[propertyOldName];
      } else if (propertyName === 'productRating') {
        mappedFeedback.rating = feedback[propertyOldName];
      } else if (propertyName === 'publishDate') {
        mappedFeedback[propertyName] = convertFeedbackModelDate(feedback[propertyOldName]);
      } else if (propertyName === 'preview') {
        const previewObject = { ...feedback[propertyOldName] };
        mappedFeedback.title =
          mappedFeedback.title ||
          (previewObject.Name && `Отзыв о ${previewObject.Name}`) ||
          undefined;
        // mappedFeedback.product = {};
        // mappedFeedback.product.name = previewObject.Name;
        // mappedFeedback.product.preposition = previewObject.Preposition;
        // mappedFeedback.product.imageUrl = previewObject.ImageViewModel.ImageUrl;
        // mappedFeedback.product.thumbUrl = previewObject.ImageViewModel.ThumbUrl;
      } else {
        mappedFeedback[propertyName] = feedback[propertyOldName];
      }
    });
    return mappedFeedback;
  });
};
/**
 * Getter for fetched total amount of feedbacks
 */
export const getFetchedFeedbackCount = (oldCount, feedbacksData) => {
  if (feedbacksData && feedbacksData.Pagination) {
    return feedbacksData.Pagination.TotalCount;
  }
  /**
   * in order, if no data come
   */
  return oldCount;
};
